import React from 'react';
import './GallerySection.css';
export default function DentalPracticeCollage() {
  
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

  return (
    <div className="collage-container" aria-labelledby="clinic-gallery">
      <div className="collage-grid" role="region" aria-label="Gallery of Dr. C Dental Clinic">
        {/* Top row */}
        <div className="collage-item item-large">
          <img 
            src="https://i.ibb.co/k2XzDfHP/image-4-9.png" 
            alt="Dentist analyzing dental x-ray scan with patient in modern clinic- Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
            loading="lazy"
          />
        </div>
        <div className="collage-item">
          <img 
            src="https://i.ibb.co/4gnm0QpZ/image-5.png" 
            alt="Friendly dental staff celebrating teamwork in clinic - Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
            loading="lazy"
          />
        </div>
        <div className="collage-item">
          <img 
            src="https://i.ibb.co/JWh3XBHV/image-7.png" 
            alt="Dentist holding sterilized dental tools in front of clinic logo - Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
            loading="lazy"
          />
        </div>
        {/* Bottom row */}
        <div className="collage-item">
          <img 
            src="https://i.ibb.co/7NZrPq8G/Image-Placeholder-4.png" 
            alt="Doctor consulting patient about oral health and treatment options - Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
            loading="lazy"
          />
        </div>
        <div className="collage-item">
          <img 
            src="https://i.ibb.co/CKbPKvbx/Image-Placeholder-2.png" 
            alt="Senior citizens receiving personalized dental care consultation- Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
            loading="lazy"
          />
        </div>
        <div className="collage-item">
          <img 
            src="https://i.ibb.co/3yGC9RLF/image-4-12.png" 
            alt="Mother with baby waiting for pediatric dental checkup- Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
            loading="lazy"
          />
        </div>
        <div className="collage-item">
          <img 
            src="https://i.ibb.co/XxpFM7v0/image-4-4.png" 
            alt="Patient checking in at dental clinic reception - Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
}